import { Box, SimpleGrid, Text } from '@chakra-ui/react';
import {
  PlusIcon,
  Squares2X2Icon,
  RectangleStackIcon,
  MagnifyingGlassIcon,
  ShareIcon,
} from '@heroicons/react/24/outline';
import QuickActionTile from './quick-action-tile';

type Props = {
  onCreateContent?: () => void;
  onBuildCollection?: () => void;
  onBrowseContent: () => void;
  onFindContent: () => void;
  onShareContent: () => void;
};

export default function QuickActions({
  onCreateContent,
  onBuildCollection,
  onBrowseContent,
  onFindContent,
  onShareContent,
}: Props) {
  return (
    <Box mb={8}>
      <Text
        fontSize='xs'
        fontWeight='bold'
        letterSpacing='widest'
        color='gray.500'
        mb={3}
        textTransform='uppercase'
      >
        Quick actions
      </Text>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} gap={3}>
        {onCreateContent && (
          <QuickActionTile
            icon={PlusIcon}
            title='Create content'
            description='A drill, play, skill, tactic…'
            iconBg='orange.100'
            onClick={onCreateContent}
          />
        )}
        {onBuildCollection && (
          <QuickActionTile
            icon={Squares2X2Icon}
            title='Build a collection'
            description='Assemble a playbook or plan'
            iconBg='purple.100'
            onClick={onBuildCollection}
          />
        )}
        <QuickActionTile
          icon={RectangleStackIcon}
          title='Browse content'
          description='Jump into a library'
          iconBg='green.100'
          onClick={onBrowseContent}
        />
        <QuickActionTile
          icon={MagnifyingGlassIcon}
          title='Find content'
          description='Search across everything'
          iconBg='blue.100'
          onClick={onFindContent}
        />
        <QuickActionTile
          icon={ShareIcon}
          title='Share content'
          description='Send a link or print a copy'
          iconBg='pink.100'
          onClick={onShareContent}
        />
      </SimpleGrid>
    </Box>
  );
}
